export class Logger {
    log(...args) {
        console.log("[Jolt] ", ...args);
    }
}
export class NullLogger extends Logger {
    log() {
        // Do nothing
    }
}
//# sourceMappingURL=Logger.js.map